module.exports = __webpack_public_path__ + "img/community-message-1.a9bda2e1.png";